'use strict';

module.exports.etfEquityQuoteGrid = function () {
    const outstandingClassnames =
        'qmod-line-sep qmod-quote-element qmod-quote-element-shareclasslevelsharesoutstanding';
    const dividendFormatter =
        '{data.fundamental.dividend.latestamount.content | asQHLast tLang}' +
        ' {data.fundamental.dividend.latestamount.currency}';

    return `
        <div rv-if="data.datatype | or 'etf' 'equity'">
            <div class="pure-g quote-section">
                <div class="pure-u-1-1 pure-u-sm-1-2">
                    <div class="qmod-box-wrap qmod-box-wrap-l">
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-open"
                            rv-if="data.pricedata.open"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.open| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr" aria-label="open">
                                    {data.pricedata.open | asQHLast tLang}
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-high"
                            rv-if="data.pricedata.high"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.high| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr" aria-label="high">
                                    {data.pricedata.high | asQHLast tLang}
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-week52high"
                            rv-if="data.fundamental.week52high"
                        >
                            <div class="pure-u-1-2"><div class="qmod-label qmod-textl">52wk High</div></div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr">
                                    <a class="qmod-popup-link"
                                        rv-on-click="data.togglePopup"
                                        data-popuptype="week52low"
                                        aria-label="Week 52 high"
                                    >
                                        {data.fundamental.week52high.content | asQHLast tLang}
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-sharevolume"
                            rv-if="data.pricedata.sharevolume"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.volume| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr">
                                    {data.pricedata.sharevolume | numeraljs '0.00a'}
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-beta"
                            rv-if="data.fundamental.beta"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.beta| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr" aria-label="beta">
                                    {data.fundamental.beta | numeraljs}
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-peratio"
                            rv-if="data.fundamental.peratio"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.peratio| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr" aria-label="PE Ratio">
                                    {data.fundamental.peratio | asQHLast tLang}
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-eps"
                            rv-if="data.fundamental.eps"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.eps| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr" aria-label="EPS">
                                    {data.fundamental.eps | numeraljs}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pure-u-1-1 pure-u-sm-1-2">
                    <div class="qmod-box-wrap qmod-box-wrap-r">
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-prevclose"
                            rv-if="data.pricedata.prevclose"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.prevclose| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr" aria-label="Prev Close">
                                    {data.pricedata.prevclose | asQHLast tLang}
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-low"
                            rv-if="data.pricedata.low"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.low| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr" aria-label="Low">
                                    {data.pricedata.low | asQHLast tLang}
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-week52low"
                            rv-if="data.fundamental.week52low"
                        >
                            <div class="pure-u-1-2"><div class="qmod-label qmod-textl">52wk Low</div></div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr" aria-label="52 Week low">
                                    <a class="qmod-popup-link"
                                        rv-on-click="data.togglePopup"
                                        data-popuptype="week52low"
                                    >
                                        {data.fundamental.week52low.content | asQHLast tLang}
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-marketcap"
                            rv-if="data.fundamental.marketcap"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl" rv-if="scope.modifiedMarketCap | = 'both'">
                                    {tplLang.marketcapac| toLang tLang}
                                </div>
                                <div class="qmod-label qmod-textl"
                                    rv-unless="scope.modifiedMarketCap | = 'both'"
                                >
                                    {tplLang.marketcap| toLang tLang}
                                </div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr">
                                    { data.fundamental.marketcap | numeraljs '0.00a'}
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-totalshares"
                            rv-if="data.fundamental.totalsharesoutstanding"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.totalshares| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr" aria-label="total shares outstanding">
                                    {data.fundamental.totalsharesoutstanding | numeraljs '0.00a'}
                                </div>
                            </div>
                        </div>
                        <div class="${outstandingClassnames}"
                            rv-if="data.fundamental.shareclasslevelsharesoutstanding"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.sharesout| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr"
                                    aria-label="share class level shares outstanding"
                                >
                                    {data.fundamental.shareclasslevelsharesoutstanding | numeraljs '0.00a'}
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-pbratio"
                            rv-if="data.fundamental.pbratio"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.pbratio| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr" aria-label="PB Ratio">
                                    {data.fundamental.pbratio | asQHLast tLang}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="pure-g quote-section">
                <div class="pure-u-1-1 pure-u-sm-1-2">
                    <div class="qmod-box-wrap qmod-box-wrap-l">
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-bid"
                            rv-if="data.pricedata.bid"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.bid| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr" aria-label="bid">
                                    {data.pricedata.bid | asQHLast tLang}
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-bidsize"
                            rv-if="data.pricedata.bidsize"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.bidsize| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr" aria-label="bidsize">
                                    {data.pricedata.bidsize | numeraljs '0'}
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-vwap"
                            rv-if="data.pricedata.vwap"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.vwap| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr" aria-label="VWAP">
                                    {data.pricedata.vwap| numeraljs}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pure-u-1-1 pure-u-sm-1-2">
                    <div class="qmod-box-wrap qmod-box-wrap-r">
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-ask"
                            rv-if="data.pricedata.ask"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.ask| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr" aria-label="Ask">
                                    {data.pricedata.ask | asQHLast tLang}
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-asksize"
                            rv-if="data.pricedata.asksize"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.asksize| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr" aria-label="Ask Size">
                                    {data.pricedata.asksize | numeraljs '0'}
                                </div>
                            </div>
                        </div>


                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-exShName"
                            rv-if="data.key.exShName"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">
                                    {tplLang.exchange| toLang tLang}
                                </div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr">
                                    <a class="qmod-tooltip"
                                        rv-title="data.key.exLgName"
                                        rv-on-mouseenter="data.qmtooltip"
                                        aria-label="exchange"
                                    >
                                        {data.key.exShName}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="pure-g quote-section">
                <div class="pure-u-1-1 pure-u-sm-1-2">
                    <div class="qmod-box-wrap qmod-box-wrap-l">
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-dividend">
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">Dividend</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr"
                                    aria-label="Div Yield"
                                >
                                    ${dividendFormatter}
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-dividend" >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.divdate| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr"
                                    aria-label="Div Date"
                                    rv-if="data.fundamental.dividend.date"
                                >
                                    {data.fundamental.dividend.date}
                                </div>
                                <div class="qmod-data-point qmod-textr"
                                    aria-label="Div Date"
                                    rv-unless="data.fundamental.dividend.date"
                                >
                                    -
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pure-u-1-1 pure-u-sm-1-2">
                    <div class="qmod-box-wrap qmod-box-wrap-r">
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-yield">
                            <div class="pure-u-1-2"><div class="qmod-label qmod-textl">Yield</div></div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr" aria-label="Div Yield">
                                    {data.fundamental.dividend.yield | numeraljs}
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-frequency" >
                            <div class="pure-u-1-2"><div class="qmod-label qmod-textl">Div. Freq.</div></div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr"
                                    aria-label="Div Frequency"
                                    rv-if="data.fundamental.dividend.frequency"
                                >
                                    {data.fundamental.dividend.frequency}
                                </div>
                                <div class="qmod-data-point qmod-textr"
                                    aria-label="Div Frequency"
                                    rv-unless="data.fundamental.dividend.frequency"
                                >
                                    -
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;
};
